import { RewardType, CodeStatus, RewardStatus } from '../types/referral.types';

/**
 * Ödül değerini formatla
 */
export const formatRewardValue = (type: RewardType, value: number | string): string => {
  // Değeri number'a çevir
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Geçersiz sayı kontrolü
  if (isNaN(numValue)) {
    return String(value);
  }
  
  // Tam sayı mı kontrol et (ondalık kısmı 0 ise)
  const isInteger = Number.isInteger(numValue);
  const formattedValue = isInteger ? numValue.toString() : numValue.toFixed(2);
  
  switch (type) {
    case RewardType.PERCENTAGE_DISCOUNT:
      return `%${formattedValue}`;
    case RewardType.FIXED_AMOUNT_DISCOUNT:
      return `${formattedValue} TL`;
    case RewardType.FREE_SUBSCRIPTION_DAYS:
      return `${formattedValue} Gün`;
    default:
      return String(value);
  }
};

/**
 * Ödül türü label'ı
 */
export const getRewardTypeLabel = (type: RewardType): string => {
  switch (type) {
    case RewardType.PERCENTAGE_DISCOUNT:
      return 'Yüzde İndirim';
    case RewardType.FIXED_AMOUNT_DISCOUNT:
      return 'Sabit Tutar İndirimi';
    case RewardType.FREE_SUBSCRIPTION_DAYS:
      return 'Ücretsiz Abonelik Günü';
    default:
      return type;
  }
};

/**
 * Kod durumu label'ı
 */
export const getCodeStatusLabel = (status: CodeStatus): string => {
  switch (status) {
    case CodeStatus.ACTIVE:
      return 'Aktif';
    case CodeStatus.USED:
      return 'Kullanıldı';
    case CodeStatus.EXPIRED:
      return 'Süresi Doldu';
    default:
      return status;
  }
};

/**
 * Ödül durumu label'ı
 */
export const getRewardStatusLabel = (status: RewardStatus): string => {
  switch (status) {
    case RewardStatus.EARNED:
      return 'Kazanıldı';
    case RewardStatus.USED:
      return 'Kullanıldı';
    case RewardStatus.CANCELLED:
      return 'İptal Edildi';
    default:
      return status;
  }
};

/**
 * İndirim hesapla
 */
export const calculateDiscount = (
  originalPrice: number,
  rewards: Array<{ type: RewardType; value: number }>,
  coupon?: { type: RewardType; value: number }
): { discountAmount: number; finalPrice: number } => {
  let discountAmount = 0;

  // Referans ödüllerini hesapla
  rewards.forEach(reward => {
    if (reward.type === RewardType.PERCENTAGE_DISCOUNT) {
      discountAmount += (originalPrice * reward.value) / 100;
    } else if (reward.type === RewardType.FIXED_AMOUNT_DISCOUNT) {
      discountAmount += reward.value;
    }
    // FREE_SUBSCRIPTION_DAYS ödeme indirimi değil, burada hesaplanmaz
  });

  // Kupon indirimini hesapla
  if (coupon) {
    if (coupon.type === RewardType.PERCENTAGE_DISCOUNT) {
      discountAmount += (originalPrice * coupon.value) / 100;
    } else if (coupon.type === RewardType.FIXED_AMOUNT_DISCOUNT) {
      discountAmount += coupon.value;
    }
  }

  // İndirim tutarı fiyattan fazla olamaz
  discountAmount = Math.min(discountAmount, originalPrice);

  const finalPrice = Math.max(0, originalPrice - discountAmount);

  return {
    discountAmount: Math.round(discountAmount * 100) / 100,
    finalPrice: Math.round(finalPrice * 100) / 100
  };
};

